module.exports = __webpack_public_path__ + "static/media/typing.b9d03b97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXLanding/images/typing.svg
// module id = 1273
// module chunks = 0